import { type SxProps } from '@mui/material/styles';

export const styles = {
  footer: {
    backgroundColor: '#37474f',
    height: '120px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '144px',
    paddingRight: '144px',
    marginTop: 'auto',
  },
  footerLeft: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
  },
  copyright: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    color: '#78909c',
  },
  socialIcons: {
    display: 'flex',
    gap: '12px',
  },
  socialIcon: {
    width: '24px',
    height: '24px',
    backgroundColor: '#90a4ae',
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#78909c',
    },
  },
  footerCenter: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: '40px',
  },
  footerLink: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    color: '#cfd8dc',
    cursor: 'pointer',
    textDecoration: 'none',
    '&:hover': {
      color: '#ffffff',
    },
  },
} satisfies Record<string, SxProps>;
